import React, { useState } from 'react';
import type { LinkComponent } from '../../../types/builder';

interface LinkRendererProps {
  component: LinkComponent;
}

const getAnimationClass = (animation: string) => {
  const animations: Record<string, string> = {
    fadeInUp: 'animate-fadeInUp',
    fadeInDown: 'animate-fadeInDown',
    slideInLeft: 'animate-slideInLeft',
    slideInRight: 'animate-slideInRight',
    bounce: 'animate-bounce-once',
    pulse: 'animate-pulse-once',
    scaleUp: 'animate-scaleUp',
    rotateIn: 'animate-rotateIn',
  };
  return animations[animation] || '';
};

export const LinkRenderer: React.FC<LinkRendererProps> = ({ component }) => {
  const { settings } = component;
  const [isHovered, setIsHovered] = useState(false);

  // Check if using background image
  const hasBackgroundImage = settings.backgroundImage && settings.backgroundImage.trim() !== '';

  return (
    <div
      style={{
        padding: `${settings.padding}px`,
      }}
    >
      <a
        href={settings.url}
        target={settings.openInNewTab ? '_blank' : '_self'}
        rel={settings.openInNewTab ? 'noopener noreferrer' : undefined}
        onClick={(e) => e.preventDefault()}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`relative flex items-center w-full rounded-2xl transition-all duration-200 shadow-md hover:shadow-lg overflow-hidden ${getAnimationClass(settings.animation)}`}
        style={{
          backgroundColor: hasBackgroundImage ? 'transparent' : (isHovered ? settings.hoverBackgroundColor : settings.backgroundColor),
          color: settings.textColor,
        }}
      >
        {/* Background Image */}
        {hasBackgroundImage ? (
          <img
            src={settings.backgroundImage}
            alt={settings.text}
            className="w-full h-auto object-cover"
            style={{
              display: 'block',
            }}
          />
        ) : (
          <>
            {settings.icon && (
              <div 
                className="flex-shrink-0 mr-4 ml-6"
                style={{
                  width: `${settings.iconSize}px`,
                  height: `${settings.iconSize}px`,
                }}
              >
                <img
                  src={settings.icon}
                  alt={settings.text}
                  className="w-full h-full object-contain rounded-lg"
                />
              </div>
            )}
            <span
              className="flex-1 text-center font-bold py-4 px-6"
              style={{
                fontSize: `${settings.fontSize}px`,
                whiteSpace: 'pre-line',
              }}
            >
              {settings.text}
            </span>
            <div className="w-8 h-8 flex-shrink-0 mr-4 opacity-50">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
              </svg>
            </div>
          </>
        )}
      </a>
    </div>
  );
};

